import { taskService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IAttempt, IStep, StepStatus } from "@miplatform/types";

export const useWorkOrderStepCardViewModel = ({
  attempt,
  step,
  onRefresh,
}: {
  attempt: IAttempt | null;
  step: IStep;
  onRefresh?: () => void;
}) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const submitStepResult = async () =>
    stateManager.run(async () => {
      if (!step.stepResult) {
        const response = await taskService.assignments.updateStepResult({
          attemptId: attempt?.id,
          assignmentId: attempt?.assignment?.id,
          stepId: step.id,
          data: {
            status: StepStatus.Pending,
          },
          toastMessageConfig: {},
        });

        if (response.status === HTTP_STATUSES.CREATED) {
          step.stepResult = response.data;
        } else {
          return;
        }
      }

      const response = await taskService.assignments.submitStepResult({
        attemptId: attempt?.id,
        assignmentId: attempt?.assignment?.id,
        stepId: step.id,
        stepResultId: step.stepResult?.id,
        data: {
          submitAttemptOnAllStepCompletion: false,
        },
        toastMessageConfig: {
          success: {
            text: `Submitted Successfully`,
            subtext: `The step has been submitted successfully`,
          },
          error: {
            text: `Submission Failed`,
            subtext: `The step submission has failed. Please try again.`,
          },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        onRefresh?.();
      }
    });

  const undoStepResult = async () =>
    stateManager.run(async () => {
      const response = await taskService.assignments.updateStepResult({
        attemptId: attempt?.id,
        assignmentId: attempt?.assignment?.id,
        stepId: step.id,
        data: {
          status: StepStatus.Pending,
        },
        toastMessageConfig: {
          success: {
            text: `Undone Successfully`,
            subtext: `The step has been undone successfully`,
          },
          error: {
            text: `Undo Failed`,
            subtext: `The step undo has failed. Please try again.`,
          },
        },
      });

      if (response.status === HTTP_STATUSES.CREATED) {
        onRefresh?.();
      }
    });

  return {
    isLoading,
    submitStepResult,
    undoStepResult,
  };
};
